import { typeCreatorV2 } from '../../../redux/utils/common';

//  [REDUCER][TYPE]
export const SET_REGISTRATION_RECEIVED_LIST: string = typeCreatorV2(
  'RegistrationReceivedReducer',
  'SetREGISTRATION_RECEIVEDList'
);

export const SET_REGISTRATION_RECEIVED_DETAIL: string = typeCreatorV2(
  'RegistrationReceivedReducer',
  'SetREGISTRATION_RECEIVEDDetail'
);

export const SET_FE_RECEIVED_BY_REGISTRATION_RECEIVED_ID: string =
  typeCreatorV2(
    'FixedEstablishmentReceivedReducer',
    'SET_FE_RECEIVED_BY_REGISTRATION_RECEIVED_ID'
  );

export const SET_VAT_RETURN_RECEIVED_LIST: string = typeCreatorV2(
  'RegistrationReceivedListReducer',
  'SetRegistrationReceivedList'
);

export const SET_UNREAD_NOTIFICATION_COUNT: string = typeCreatorV2(
  'RegistrationReceivedListReducer',
  'SetUnreadNotificationCount'
);

export const SET_MEMBER_STATE_EXCLUDE_CYPRUS: string = typeCreatorV2(
  'RegistrationReceivedListReducer',
  'SetMemberStateCountriesExcludeCyprus'
);
